<div class="py-xl px-xxs mx-auto flex w-2/3 justify-center bg-white">
  <div class="gap-lg flex flex-col">
    @if (icone(); as icone) {
      <div class="bg-background-underground-2 size-xxl mx-auto flex items-center justify-around rounded-full">
        <ng-icon class="text-content-secondary!" [name]="icone" hlm size="sm" />
      </div>
    } @else {
      <img class="mx-auto" src="/assets/imgs/oies.svg" />
    }
    <div class="gap-sm flex flex-col">
      <p class="paragraph-medium-semibold text-content-secondary text-center">{{ title() }}</p>
      <ng-content />
    </div>
  </div>
</div>
